module.exports = {"toClipboard":"Copy","copied":"Copied","notCopied":"Not Copied"};